export default __webpack_public_path__ + "assets/Villa.db8dad4c.png";